<div style="display: flex; margin-block-end: 0.67em;">
  <h1 style="margin-block-start: 0em; margin-block-end: 0em;">Text Editor</h1>
  <button class="close" mat-button (click)="closeDialog()">X</button>
</div>
<div class="text-editor">
  <st-rich-text-editor [content]="content" (contentEvent)="onTextChanged($event)"> </st-rich-text-editor>
</div>
